import { render, staticRenderFns } from "./AddGroupAppSetting.vue?vue&type=template&id=6f0b1e20&"
import script from "./AddGroupAppSetting.vue?vue&type=script&lang=js&"
export * from "./AddGroupAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports